import React from 'react';
import { ExpertQualificationsContainer } from '../../containers';

const ExpertQualificationsPage = () => <ExpertQualificationsContainer />;

export default ExpertQualificationsPage;
